export default {
  getTableDataChart(state) {
    return state.tableData;
  },
  getHeaders(state) {
    return state.headers.map((coluna) => ({
      ...coluna,
      value: coluna.value,
      text: coluna.i18n,
    }));
  },
  getQuantidadeInventariadaCliente(state) {
    return state.quantidadeInventariadaCliente;
  },
  getCamposDataTablePorcentagemProgressBar(state) {
    return state.camposDataTablePorcentagemProgressBar;
  },
  getAcuraciaPorUnidade(state) {
    return state.acuraciaPorUnidade;
  },
  getAcuraciaPorCliente(state) {
    return state.acuraciaPorCliente;
  },
  getAcuraciaMensal(state) {
    return state.acuraciaMensal;
  },
  getAcuraciaQuantidadeItemCliente(state) {
    return state.acuraciaQuantidadeItemCliente;
  },
  getAcuraciaQuantidadeInventariadaProduto(state) {
    return state.acuraciaQuantidadeInventariadaProduto;
  },
  getInformacoesEstoque(state) {
    return state.informacoesEstoque;
  },
};
